import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import * as types from '@reserve/store/types'
import * as eventTypes from '@reserve/store/event-types'
import * as accountTypes from '@account/store/types'
import {createEventBus, openPopup} from '@appbase/util'
import reserveHelper from '../../reserve-helper'

import CompanySelectionPane from '@reserve/components/SideMenu/CompanySelectionPane.vue'
import MiniCalendar from '@reserve/components/SideMenu/MiniCalendar.vue'
import ResourceGroup from '@reserve/components/SideMenu/ResourceGroup.vue'
import ResourceBookmark from '@/modules/reserve/components/SideMenu/ResourceBookmark.vue'
import ResourceItemDb from '@reserve/components/SideMenu/ResourceItemDb.vue'
import {openReserveWindow} from '../../popup-handler'

@Component({
    components: {
        MiniCalendar,
        ResourceGroup,
        ResourceBookmark,
        ResourceItemDb,
        CompanySelectionPane
    },

    computed: mapGetters({
        user: accountTypes.USER,
        resourceGroups: types.EWS_RESOURCEGROUPS_TREE,
        resourceGroupsDb: types.DB_RESOURCEGROUPS_TREE,
        selectedResourceKeys: types.SELECTED_RESOURCE_KEYS,
        selectedResources: types.SELECTED_RESOURCE_LIST,
        bookmarkItems: types.CALENDAR_RESOURCEBOOKMARK_LIST,
        curCategory: types.CALENDAR_CATEGORY,
        curCompany: types.CALENDAR_COMPANY
    }),

    methods: {
        ...mapActions({
            fetchResources: types.CALENDAR_RESOURCE_LIST
        }),

        ...mapMutations({
            setCurCompany: types.CALENDAR_COMPANY,
            setCategory: types.CALENDAR_CATEGORY
        })
    }
})
export default class SideMenu extends Vue {
    setCurCompany!: (comCode: string | null) => void;
    setCategory!: (payload: 'FAVORITE' | 'EWS' | 'DB') => void;
    fetchResources!: (payload: {
        comCode: string | null,
        itemStore: 'FAVORITE' | 'EWS' | 'DB'
    }) => Promise<reserve.ResourceItemBase>;

    user!: account.User;
    resourceGroups!: ewsResource.EwsResourceItem[];
    resourceGroupsDb!: reserve.DbResourceItem[];
    selectedResourceKeys!: string[];
    selectedResources!: reserve.ResourceItemBase[];
    bookmarkItems!: reserve.BookmarkItem[];
    curCategory!: 'FAVORITE' | 'EWS' | 'DB';
    curCompany!: string | null;

    mMailUser: boolean = false;

    created() {
        if (this.user.isMailUser) {
            this.mMailUser = true;
        }

        if (this.curCompany == null) {
            this.setCurCompany(this.user.comCode);
        }

        createEventBus(window, eventTypes.EVENT_RESOURCE_BOOKMARKUPDATED, this.onBookmarkUpdated);
        this.fetchResources({comCode: this.curCompany, itemStore: this.curCategory});
    }

    reserveResource() {
        let resource: string | undefined;
        let selection = this.selectedResources.filter(r => !reserveHelper.isHeaderType(r.resourceType));

        if (selection.length == 1) {
            resource = selection[0].address;
        }

        openReserveWindow({
            comCode: this.curCompany,
            category: this.curCategory,
            resource: resource
        });
    }

    // 내 예약조회 팝업
    openMyReserveListPopup = function (option: reserve.ReserveWindowOption) {
        const openParam: { [key: string]: string } = {};

        if (option.comCode) {
            openParam['comCode'] = option.comCode;
        }

        if (option.category) {
            openParam['itemStore'] = option.category;
        }


        const listUrl = `${window.location.origin}` != 'http://localhost:8080'  ?
            `${window.location.origin}/po/reservePopup/myReserveList`: `${window.location.origin}/reservePopup/myReserveList`;
        openPopup('eum-reserve-list', listUrl, openParam, {
            width: 1500,
            height: 1000
        });
    };

    onResourceTabClick(tabType: 'FAVORITE' | 'EWS' | 'DB') {
        this.setCategory(tabType);
        this.fetchResources({comCode: this.curCompany, itemStore: tabType});
    }

    onBookmarkUpdated(data: { [key: string]: boolean }) {
        this.fetchResources({comCode: this.curCompany, itemStore: this.curCategory});
    }

    onCompanyChanged(company: orgmap.Company | null) {
        if (company != null) {
            this.fetchResources({comCode: company.comCode, itemStore: this.curCategory});
        }
    }
}